export const catTipoPlaza = {
    NoAplica: 0,
    Sencilla: 1,
    Doble: 2,
    Triple: 3,
    Cuádruple: 4,
    Menorinfante: 5,
    Compartida: 6,
    AlojamientoCompartido: 7,
    INFANTE: 8,
}